import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PatientList from './PatientList/PatientList';
import { setActive, getList } from '../actions/patient';
import { setUser, resetUserError } from '../actions/clinician';
import { resetRec } from '../actions/recommendations';

const mapStateToProps = state => ({ patient: state.patient, clinician: state.clinician.clinician, recommendations: state.recommendations });

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setActive,
      getList,
      setUser,
      resetUserError,
      resetRec,
    },
    dispatch,
  );


export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PatientList);




// WEBPACK FOOTER //
// ./src/components/PatientContainer.js